// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const printOptionSelector = (state: ApplicationState) => {
    return state.bunzl.components.orderDetailsTotal.hidePriceOnPrint;
};
